// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../startOfYear/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var startOfYear = convertToFP(fn, 1);
export default startOfYear;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/startOfYear/index.js
// module id = 999
// module chunks = 0